export default __webpack_public_path__ + "static/media/adwone.ad3f20f2.png";